import angular from 'angular';
import analyticsService from 'common/analytics';

// Create and register the Angular module
export default angular
    .module('application.service.analytics', [])
    .factory('analyticsService', () => analyticsService);


// WEBPACK FOOTER //
// ./src/application/service/analytics/index.js